const delAccount = () => import('../views/gp/delAccount.vue')

export default [
  {
		path: "/delAccount",
		name: "delAccount",
		component: delAccount,
		meta: {
			title: 'OKash'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/gp.js